module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('div', [_c('v-card', {
    staticClass: "pb-2",
    attrs: {
      "flat": ""
    }
  }, [(_vm.agencies.length === 1) ? _c('h4', {
    staticClass: "py-1 text-xs-center",
    staticStyle: {
      "color": "green",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.agencies[0]['administrationName']) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "py-2 ml-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THÔNG TIN HỒ SƠ ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    style: (!_vm.isMobile ? 'width: calc(100% - 120px)' : 'width: 100%')
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNoKey"
    }
  }, [_vm._v("Mã hồ sơ")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    class: _vm.isMobile ? 'mt-3' : '',
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "applicantIdNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "applicantIdNoKey"
    }
  }, [_vm._v("Số CMND/ hộ chiếu")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right px-2",
    style: (!_vm.isMobile ? 'width: 120px' : 'width: 100%')
  }, [_c('v-btn', {
    staticClass: "kios-btn mx-0",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.filterDossier
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("search")]), _vm._v("\n             \n            Tra Cứu\n            "), _c('span', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loading...")])], 1)], 1)]), _vm._v(" "), (_vm.validateTracuu === false && !_vm.activeDetailDossier) ? _c('v-alert', {
    staticClass: "mt-5 mx-2",
    attrs: {
      "value": true,
      "outline": "",
      "color": "orange",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        Nhập thông tin tra cứu\n      ")]) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && !_vm.activeDetailDossier) ? _c('div', {
    staticClass: "wrap-scroll wrap-scroll-tabledossier mx-2 mt-4",
    class: _vm.visible ? 'overlayActive' : '',
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-data-table', {
    staticClass: "table-tracuu table-landing table-bordered",
    class: _vm.visible ? 'overlayActive' : '',
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.dossierList,
      "hide-actions": "",
      "id": "tracuuhoso"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.applicantName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])])])], 1)])]
      }
    }], null, false, 1457508949)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n              Không có hồ sơ nào được tìm thấy\n            ")])])], 2), _vm._v(" "), (_vm.totalPages > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPages,
      "page": _vm.hosoDatasPage,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && _vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-2 mt-3"
  }, [_c('chi-tiet-ho-so', {
    attrs: {
      "index": _vm.dossierDetail.dossierId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n          "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4aca7818", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aca7818"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraCuuHoSo.vue
// module id = 528
// module chunks = 1